import { Direction } from "reactstrap/types/lib/Dropdown";
import { CardSubtitle } from "./CoreComponents";
import { ReactNode } from "react";

export interface TabContentProp {
  tabId: string;
}

export interface DropdownItems {
  class: string;
  divClass?: string;
  bodyClass?: string;
  position?: Direction;
  text: string;
  menulist: string[];
  size?: string;
}

export interface DropdownProp {
  item: DropdownItems;
  toggleClass?: string;
}

export interface BasicDropdownProps {
  title: string;
  span?: CardSubtitle[];
  colClass?: string;
  toggleClass?: string;
  bodyClass?: string;
  data: DropdownItems[];
}

export interface CollapseState {
  collapse1: boolean;
  collapse2: boolean;
}

export enum Placement {
  Top = "top",
  Bottom = "bottom",
  Left = "left",
  Right = "right",
}

export interface PopoverItems {
  id?: string;
  placement: Placement;
  popoverHeader?: string;
  popoverBody?: string;
  btnColor?: string;
  btnText?: string;
  trigger?: string;
  size?: string;
}

export interface PopoverProp {
  data: PopoverItems;
}

export interface TooltipState {
  tooltip1: boolean;
  tooltip2: boolean;
  tooltip3: boolean;
}

export interface ModalItems {
  isOpen: boolean;
  header?: boolean;
  class?: string;
  footer?: boolean;
  toggler: () => void;
  title?: string;
  size?: string;
  bodyClass?: string;
  button?: string;
  center?: boolean;
}

export interface ModalProps {
  modalData: ModalItems;
  children: string | React.JSX.Element | React.JSX.Element[];
}

export interface ModalBodyProps {
  modal: boolean;
  toggle: () => void;
}

export interface StaticModalProp {
  toggle: () => void;
}

export interface GridFooterProps {
  code: string;
  value: string;
}

export interface ThemeModalProps {
  heading: string;
  subHeading: string;
  text: string;
}

export interface CustomModalProps {
  modal: boolean;
  toggle: () => void;
}

export interface ChildrenItem {
  text: string;
  class: string;
  textClass: string;
  alertText: string;
  icons?: React.JSX.Element;
}

export interface LinkColor {
  data: ChildrenItem[];
}

export interface LinkColorProps {
  title: string;
  data: LinkColor[];
  text?: boolean;
  bodyClass?: string;
  icon?: boolean;
}

export interface BelowModalProps {
  title?: string;
  modalClass?: string;
  color?: string;
}

export interface Badges {
  id: number;
  color?: string;
  text?: string;
  iconName?: ReactNode;
  badgeClass?: string;
}

export interface BadgesProps {
  title: string;
  span: CardSubtitle[];
  data: Badges[];
  roundedPills?: boolean;
  number?: boolean;
  className?: string;
  icon?: boolean;
}

export interface ProgressProps {
  title: string;
  span: CardSubtitle[];
  data: ProgressList[];
  striped?: boolean;
  animated?: boolean;
  tag?: boolean;
  progressClass?: string;
  value?: boolean;
}

//Accordion
export interface AccordionItems {
  id: string;
  icon: boolean;
  accordionHeading: string;
  bodyText: JSX.Element;
}

export interface Items {
  text: string;
}

export interface FlushList {
  id: string;
  head: string;
  child: Items[];
}

export interface IconDemoItems {
  id: string;
  icon: JSX.Element;
  head: string;
  text: JSX.Element;
}

//Alert
export interface Alerts {
  text: string;
  class: string;
  alertText: string;
  textClass: string;
  icons?: JSX.Element;
}

export interface AlertColors {
  data: Alerts[];
}

export interface AdditionalAlert {
  class: string;
  head: string;
  text: string;
  subtext: string;
}

//Avtar
export interface AvatarsList {
  id?: number;
  class: string;
  image: string;
  status?: string;
}

export interface GroupAvtar {
  id: number;
  child: AvatarsList[];
}

//Grid
export interface GridTableHead {
  class?: string;
  text1: string;
  text2: string;
}

export interface GridTableBody {
  xs: number;
  order?: string;
  text: string;
  sm?: number;
  class?: string;
}

//HelperClasses
export interface BorderColorItems {
  id: number;
  color: string;
}

export interface ImageItem {
  size: string;
}

export interface FontStyle {
  class: string;
  text: string;
  text2?: string;
}

//List
export interface ListItem {
  id?: string;
  class: string;
  htmlText: JSX.Element;
}

export interface HorizontalList {
  class: string;
  data: string[];
}

export interface CustomList {
  class: string;
  head: string;
  mail: string;
  image: string;
  span: string;
  subtext: string;
  follower: string;
}

export interface ListFormGroup {
  class: string;
  text: string;
  idFor?: string;
  check?: string;
}

export interface BadgeList {
  text: string;
  badgeClass: string;
  badgeText: string;
}

export interface DisableList {
  class: string;
  image: string;
  text: string;
}

export interface ScrollList {
  image: string;
  head: string;
  mail: string;
  small: string;
}

//Modal
export interface ModalTooltip {
  id: string;
  content: string;
  text: string;
}

export interface ModalItemsList {
  class?: string;
  text: string;
  title?: string;
}

export interface BalanceWrap {
  id: number;
  color: string;
  text: string;
  rate: number;
  badge: string;
}

//Progress
export interface ProgressList {
  class?: string;
  value: string;
  text?: string;
}

export interface MultipleBarItem {
  data: ProgressList[];
}

//Tabs
export interface TabsList {
  id: string;
  text: JSX.Element;
}

export interface NavItems {
  title: string;
  icon: string;
}

export interface TabItems {
  image: string;
  head: string;
  text: string;
}

export interface JustifyTab {
  id: string;
  data: TabItems[];
}

export interface TabMaterial {
  title: string;
  headers: string[];
  rows: (string | JSX.Element)[][];
}

export interface MaterialItems {
  id: string;
  data: TabMaterial;
}

//Tag & Pills
export interface BadgeTagPill {
  id: number;
  color?: string;
  text?: string;
  iconName?: JSX.Element;
  class?: string;
}

//Tooltip
export interface TooltipList {
  class: string;
  position?: string;
  text?: string;
  tooltip?: JSX.Element;
}

//Typography
export interface HeadingHead {
  name: string;
}

export interface ColorTypography {
  class: string;
  name?: string;
  text?: string;
}

export interface BlockQuotes {
  color: string;
  text: string;
  footer: string;
  class?: string;
}
